FormFields = require './internal/form-fields'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')

module.exports = class extends React.Component
  displayName: 'TermsOfServiceComponent'

  formFields: ['acceptTOS']
  requiredFields:
    acceptTOS: true

  render: t.renderable ->
    { errorField } = @props
    isError = errorField == 'acceptTOS'

    render = ({ formState, setFormState }) ->
      onChange = (e) =>
        setFormState(acceptTOS: e.target.checked)

      checked = formState.acceptTOS

      t.div id: 'divAcceptTOS', ->
        t.div '.check-div.u-clearfix', ->
          t.input { class: t.classify('input-error': isError), type: 'checkbox', checked, onChange }
          t.label { htmlFor: 'tos' }, ->
            t.format 'i-accept-the-terms-of-service-and-the-privacy-policy'
        if isError
          t.p '.u-form-error.error', ->
            t.format 'you-must-accept-the-terms-of-service-and-privacy-policy'

    t.tag FormFields, {
      render
      @formFields
      @requiredFields
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      initialState: {
        acceptTOS: false
      }
    }
